import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

import { BaseEntityAssociationController } from "../ts/rlAdmin.controllers";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { AdminService } from "../services/admin-service";
import { AclService } from "../services/acl-service";
import { SearchService } from "../services/search-service";

export function RLAssociationPanels() {
	var directive: ng.IDirective = {
		restrict: "AE",
		template: require("/assets/app/templates/association-panels.html"),
		controller: RLAssociationPanelsController,
		controllerAs: "apVM",
		bindToController: true,
		scope: {
			filterByEntityID: "=filterByEntityId",
			locked: "=",
			charTypesAndTemplateGroups: "=",
			searchStates: "=",
			selectedRecords: "=",
			associateCharType: "=",
			selectedCharType: "=",
			currentCharTypeAndTemplateGroup: "=",
			canCreate: "=?",
			canEdit: "=?",
			parentCharTypeID: "=?parentCharTypeId",
			templateGroupIDs: "=?templateGroupIds",
			refreshPanels: "=?"
		}
	};

	return directive;
}

export class RLAssociationPanelsController extends BaseEntityAssociationController {
	static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q", "eventService", "entityService", "adminService", "$interval", "aclService", "searchService"];
	filterByEntityID: string;
	locked: boolean;
	charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
	searchStates: { [key: string]: Models.IAdvancedSearchModel };
	selectedRecords: any[];
	modalOpen: boolean;
	associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
	canCreate: boolean;
	canEdit: boolean;
	parentCharTypeID: number;
	templateGroupIDs: number[];
	refreshPanels: boolean;

	localCharTypes: Models.IAssociationCharTypeAndTemplateGroupExtended[];
	direction: number;

	hasModalBeenShown: boolean;

	entityTemplateID: number;
	multiSelect: boolean;
	isAssociation: boolean;

	activeFlag: boolean;

	//Intra-char
	detailsUrl: string;
	entityTitle: string;
	entityRecID: number;
	isCatalogCharType: boolean;
	showInventory: boolean;
	showParents: boolean;
	toggleRefresh: boolean;
	isExpanded: boolean;
	isChecked: boolean;
	selected: {
		search: { [key: number]: boolean };
		ids: string[];
	};
	association: {
		itemRows: any[];			    // search result item rows
		page: number;				    // current page
		pageCount: number;			    // current page	count of search	results
		numFound: number;
		initialized: boolean;
		templates: Models.IKeyValuePair<string, number>[];			// template	data for select	box        
		open: boolean;
	};
	//nodes: Models.IEntitySearchDoc[];
	intraCharParentRows: Models.IEntitySearchDoc[];
	showAdvance: boolean //set to true for allowing Search to show advance tab 
	selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[]; //selected valid record after using advance search option
	// --

	//Permissions
	charTypeCanEdit: { [charTypeID: number]: boolean };
	charTypeCanDelete: { [charTypeID: number]: boolean };
	//--

	//Association Table
	selectedCustomColumns: { [key: string]: Models.ICustomUserColumns };
	itemRows: { [key: string]: Models.IEntitySearchDoc[] };
	rowCount: { [key: string]: number };
	numFound: { [key: string]: number };
	pageCount: { [key: string]: number };
	page: { [key: string]: number };
	sortField: { [key: string]: string };
	sortDir: { [key: string]: number };
	deleteRecordNotifiationText: string;
	removeRecordAssoctaionModalOpen: boolean;
	removeRecordAssociationModelTitle: string;
	selectedRecordsForCharType: { [childCharTypeID: number]: Models.IListTableRow[] } = {};
	selectedRemoveChildCharTypeID: number;
	canCreateFromAssociation: boolean;

	constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
		public notifyService: NotifyService, private $window: ng.IWindowService,
		public $q: ng.IQService,
		private eventService: EventService,
		private entityService: EntityService,
		public adminService: AdminService,
		public $interval: ng.IIntervalService,
		public aclService: AclService,
		private searchService: SearchService) {

		super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

		this.hasModalBeenShown = false;

		this.localCharTypes = [];
		this.direction = 0;
		this.multiSelect = true;
		this.isAssociation = false;

		this.activeFlag = false;

		//Intra-char
		this.detailsUrl = "";
		this.entityRecID = Utils.IdBuilder.splitEntityID(this.filterByEntityID).recID;
		this.isCatalogCharType = Utils.IdBuilder.splitEntityID(this.filterByEntityID).charTypeID == Consts.CharTypeIDs.property;
		this.showInventory = false;
		this.showParents = false;
		this.toggleRefresh = false;
		this.association = { initialized: false, itemRows: [], numFound: 0, page: 0, pageCount: 0, templates: [], open: true };
		this.selected = {
			search: {},
			ids: []
		};
		this.showAdvance = true;
		this.selectedRecIdTitlePairs = [];
		//--

		//Permissions
		this.charTypeCanEdit = {};
		this.charTypeCanDelete = {};
		//--

		//Association Table
		this.selectedCustomColumns = {};
		this.itemRows = {};
		this.rowCount = {};
		this.numFound = {};
		this.pageCount = {};
		this.page = {};
		this.sortField = {};
		this.sortDir = {};

		//--
		this.deleteRecordNotifiationText = "";
		this.removeRecordAssoctaionModalOpen = false;
		this.removeRecordAssociationModelTitle = "";
		this.selectedRecordsForCharType = {};
		this.selectedRemoveChildCharTypeID = 0;
		this.canCreateFromAssociation = false;

		$scope.$watch(() => this.filterByEntityID, (newValue: string, oldValue: string) => {
			if (newValue != null) {
				//this.nodes = [];
				this.entityService.getEntity(this.filterByEntityID)
					.then((result) => {
						this.entityTemplateID = result.record.templateID;
						this.entityTitle = result.record.title;
					});

				this.entityService.getEntityStatus(this.filterByEntityID)
					.then((result) => {
						this.activeFlag = result.activeIndicator == 1 ? true : false;
					});


			}
		});		

		$scope.$watch(() => this.refreshPanels, (newValue: boolean, oldValue: boolean) => {
			if (newValue != null && newValue) {
				this.RefreshAll();
				this.refreshPanels = false;
			}
		}, true);

		$scope.$watch(() => this.searchStates, (newValue, oldValue) => {
			if (newValue != oldValue) {
				var keys = _.keys(this.searchStates);

				keys.forEach(k => {
					var searchState = this.searchStates[k];
					this.Search(searchState, k);
				});
			}
		}, true);

		$scope.$watch(() => this.page, (newValue, oldValue) => {
			if (newValue != oldValue) {
				var keys = _.keys(newValue);

				keys.forEach(k => {
					var searchState = this.searchStates[k];
					if (searchState != null) {
						searchState.page = newValue[k];
						if (newValue[k] != oldValue[k] && this.currentCharTypeAndTemplateGroup.charTypeID != searchState.charTypeID) {
							this.Search(searchState, k);
						}
					}
				});
			}
		}, true);

		$scope.$watch(() => this.rowCount, (newValue, oldValue) => {
			if (newValue != oldValue) {
				var keys = _.keys(newValue);

				keys.forEach(k => {
					var searchState = this.searchStates[k];
					searchState.rowCount = newValue[k];
					if (newValue[k] != oldValue[k] && this.currentCharTypeAndTemplateGroup.charTypeID != searchState.charTypeID) {
						this.Search(searchState, k);
					}
				});
			}
		}, true);

		$scope.$watch(() => this.sortField, (newValue, oldValue) => {
			if (newValue != oldValue) {
				var keys = _.keys(newValue);
				keys.forEach(k => {
					var searchState = this.searchStates[k];
					var sortField = newValue[k];

					//Change the sort column 
					if (sortField == 'title') {
						sortField = 'title_sort';
					}

					searchState.sortField = sortField;
					searchState.sortDir = this.sortDir[k] || 0;
					if (newValue[k] != oldValue[k]) {
						this.Search(searchState, k);
					}
				});
			}
		}, true);

		$scope.$watch(() => this.sortDir, (newValue, oldValue) => {
			if (newValue != oldValue) {
				var keys = _.keys(newValue);
				keys.forEach(k => {
					var searchState = this.searchStates[k];
					if (searchState != undefined) {
						searchState.sortDir = newValue[k];
						if (newValue[k] != oldValue[k]) {
							this.Search(searchState, k);
						}

					}
				});
			}
		}, true);

		$scope.$watch(() => this.charTypesAndTemplateGroups, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.GetPermissions();
			}
		}, true);
	}

	$onInit() {
		this.ShowParentsToggle();	
	}

	RefreshAll() {
		this.eventService.call(Consts.Events.EntityAssociationSearchRefreshAll)
			.then(() => {
				var keys = _.keys(this.searchStates);

				keys.forEach(k => {
					var searchState = this.searchStates[k];
					this.Search(searchState, k);
				});

				if (this.showParents) {
					this.GetEntityParents()
						.then((results) => {
							this.intraCharParentRows = results.data;

							if (results.data == null || results.data.length == 0) {
								this.showParents = false;
							}
						});
				}

				this.eventService.call(Consts.Events.ValidateEntity)
					.then(() => {
						this.modalOpen = false;
						this.progressModalOpen = false;
					});
			});
	}

	AssociateSelected() {
		var childEntityIDs: string[] = [];
		_.each(this.selectedRecords, r => {
			if (!_.isUndefined(r.entityID) && r.entityID != this.filterByEntityID) {
				childEntityIDs.push(r.entityID);
			}
		});

		if (this.selectedRecIdTitlePairs.length > 0) {
			var divID = Utils.IdBuilder.splitEntityID(this.filterByEntityID).divID;
			this.selectedRecIdTitlePairs.forEach((recIDTitlePair) => {
				var childEntityID = Utils.IdBuilder.buildEntityID(divID, this.associateCharType.charTypeID, recIDTitlePair.key);
				if (!_.isUndefined(childEntityID) && childEntityID != this.filterByEntityID) {
					childEntityIDs.push(childEntityID);
				}
			});
		}

		if (childEntityIDs.length > 0) {
			this.notifyService.startProgress();

			this.entityService.associateEntity(this.filterByEntityID, childEntityIDs, this.direction)
				.then((result) => {
					if (_.isEmpty(result.jobTitle)) {
						this.notifyService.notifyError("There was an error associating these records.\n Please make sure you are not attempting to create a circular reference.");
						this.selectedRecords = [];
						this.modalOpen = false;
					}
					else {
						var jobID = result.jobID;
						this.jobTitle = result.jobTitle;

						this.ShowProgress(jobID, () => {
							this.RefreshAll();
						});
					}
				}, (event) => {
					// error handler
					this.notifyService.notifyError("There was an error associating these records.\n Please make sure you are not attempting to create a circular reference.");
				})
				.then(() => {
					// close modal
					this.modalOpen = false;
				})
				.finally(() => {
					// end progress bar
					this.notifyService.endProgress();
				});
		}
		else {
			this.modalOpen = false;
			this.notifyService.notifyError("No associations found. Can't create self-referencing association.");
		}
	}

	OpenAssociationModal(charType: Models.IAssociationCharTypeAndTemplateGroupExtended) {
		this.selectedRecIdTitlePairs = [];
		this.associateCharType = charType;
		this.modalOpen = true;
		this.isAssociation = true;

		if (this.hasModalBeenShown) {
			this.toggleRefresh = true;
		}

		this.hasModalBeenShown = true;

		var targetACL = Utils.AclUtil.getDataEntityAcl(charType.charTypeID, -1, -1);		
		this.canCreateFromAssociation = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);

		if (this.associateCharType.charTypeID != this.currentCharTypeAndTemplateGroup.charTypeID) {
			if (this.associateCharType.isParentChar) {
				this.direction = 1;
			}
			else {
				this.direction = 0;
			}
		}
	}

	GetCharTypeName(charTypeID: number): string {
		var charName = _.first(this.charTypesAndTemplateGroups.filter(c => c.charTypeID == charTypeID)).name;

		return charName;
	}

	GetPermissions() {
		this.aclService.loadActivityAcls()
			.then((acls) => {
				var aclString = "acl://activity/site/mod";

				_.forEach(this.charTypesAndTemplateGroups, (ctatg) => {
					if (ctatg.isParentChar) {
						aclString += ctatg.charTypeID;
					}
					else {
						aclString += this.currentCharTypeAndTemplateGroup.charTypeID;
					}

					this.charTypeCanEdit[ctatg.charTypeID] = Utils.AclUtil.hasWriteAccess(acls, aclString);
					this.charTypeCanDelete[ctatg.charTypeID] = Utils.AclUtil.hasDeleteAccess(acls, aclString);
				});
			});
	}

	//Intra-char Functions
	CollapseToggle() {
		this.association.open = !this.association.open;
	}

	ShowParentsToggle() {
		this.showParents = !this.showParents;

		//Get Parent Nodes
		this.GetEntityParents()
			.then((results) => {
				this.intraCharParentRows = results.data;

				if (results.data == null || results.data.length == 0) {
					this.showParents = false;
				}
			});
	}

	GetEntityParents() {
		return this.searchService.getEntityParents(this.filterByEntityID);
	}

	ShowInventoryToggle() {
		if (this.showInventory) {
			this.templateGroupIDs = [1, 2];
		}
		else {
			this.templateGroupIDs = [1];
		}
	}
	//--

	//Association Table
	Search(searchState, charTypeName): ng.IPromise<any> {
		if (!_.isEmpty(searchState)) {
			this.notifyService.startProgress();
			return this.searchService.advancedSearch(searchState)
				.then((res) => {
					//console.log(res.documents);
					this.itemRows[charTypeName] = res.documents;
					this.numFound[charTypeName] = res.numFound;
					this.pageCount[charTypeName] = Math.ceil(res.numFound / searchState.rowCount);
					this.rowCount[charTypeName] = searchState.rowCount;
					this.page[charTypeName] = searchState.page;
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}
	//--

	RefreshContactPartyOnDeals(charTypeID: number) {
		var searchState: any = _.find(this.charTypesAndTemplateGroups, s => s.charTypeID == charTypeID);
		if (!_.isEmpty(searchState)) {
			searchState.relatedEntityID = this.filterByEntityID;
			return this.searchService.syncContactPartyOnEntities(searchState)
				.then((result) => {
					var jobID = result.jobID;
					this.jobTitle = result.jobTitle;

					this.ShowProgress(jobID, () => {
						this.notifyService.notifySuccess("Update Contact Details on all associated Deal");
						this.RefreshAll();
					});
				});
		}
	}

	ShowRemoveAllAssociation(charType: Models.IAssociationCharTypeAndTemplateGroupExtended) {
		var parsedEntityID = Utils.IdBuilder.splitEntityID(this.filterByEntityID);

		if (parsedEntityID.charTypeID == Consts.CharTypeIDs.transaction && charType.charTypeID == Consts.CharTypeIDs.property) {
			var catalogItemRecordIds = this.selectedRecordsForCharType[charType.charTypeID].map(r => r.recordID);
			this.entityService.getExistingCatalogItemsFromDealToInvoices(parsedEntityID.recID, catalogItemRecordIds)
				.then((result) => {
					var breakDelete: boolean = false;
					if (result.success) {
						breakDelete = _.any(result.data, r => catalogItemRecordIds.indexOf(r) > -1);
					}
					else {
						breakDelete = true;
					}

					if (breakDelete) {
						this.$window.alert("Unable to delete these catalog items because there are one or more associated accounting records.");
					}
					else {
						this.ProcessRemoveAllAssociation(charType);
					}
				});
		}
		else {
			this.ProcessRemoveAllAssociation(charType);
		}
	}


	ProcessRemoveAllAssociation(charType: Models.IAssociationCharTypeAndTemplateGroupExtended) {
		this.selectedRemoveChildCharTypeID = charType.charTypeID;
		this.removeRecordAssociationModelTitle = "Remove " + this.GetCharTypeName(charType.charTypeID) + " from " + this.GetCharTypeName(this.parentCharTypeID) + "?";

		if (_.isEmpty(this.selectedRecordsForCharType[this.selectedRemoveChildCharTypeID])) {
			alert("No Associated Records selected to remove. Please select some associated record to remove");
		}
		else {
			if (charType.charTypeID == Consts.CharTypeIDs.project || charType.charTypeID == Consts.CharTypeIDs.property) {
				if (this.parentCharTypeID == Consts.CharTypeIDs.transaction) {
					if (charType.charTypeID == Consts.CharTypeIDs.property) {
						this.deleteRecordNotifiationText = "Any related Catalog Items will be removed from any Rights, Tables and Amounts on this Deal." + this.entityTitle + " <br/> Are you sure you want to remove this association?"
					}
					else {
						this.deleteRecordNotifiationText = this.GetCharTypeName(charType.charTypeID) + " will be removed from any Tables on this Deal." + this.entityTitle + " <br/> Are you sure you want to remove this association?"
					}
				}
				else {
					this.deleteRecordNotifiationText = this.GetCharTypeName(charType.charTypeID) + " will be removed from any Tables on this " + this.GetCharTypeName(this.parentCharTypeID) + ".<br/> Are you sure you want to remove this association?"
				}
				this.removeRecordAssoctaionModalOpen = true;
			}
			else {
				this.removeRecordAssoctaionModalOpen = true;
				this.deleteRecordNotifiationText = this.GetCharTypeName(charType.charTypeID) + " will be removed from this " + this.GetCharTypeName(this.parentCharTypeID) + ".<br/> Are you sure you want to remove this association?"
			}
		}
	}

	RemoveAssociationToRecord(selectedRemoveChildCharTypeID: number) {
		if (selectedRemoveChildCharTypeID > 0) {
			if (selectedRemoveChildCharTypeID != this.currentCharTypeAndTemplateGroup.charTypeID) {
				this.associateCharType = _.find(this.charTypesAndTemplateGroups, i => i.charTypeID == selectedRemoveChildCharTypeID);
				if (this.associateCharType.isParentChar) {
					this.direction = 1;
				}
				else {
					this.direction = 0;
				}
			}

			this.notifyService.startProgress();
			var divID = Utils.IdBuilder.splitEntityID(this.filterByEntityID).divID;
			var childEntityIDs: string[] = [];
			var selectedRecords = this.selectedRecordsForCharType[selectedRemoveChildCharTypeID];

			_.each(selectedRecords, r => {
				var childEntityID = Utils.IdBuilder.buildEntityID(divID, selectedRemoveChildCharTypeID, r.recordID);
				childEntityIDs.push(childEntityID);
			});

			if (childEntityIDs.length > 0) {
				this.entityService.removeAssociatedEntities(this.filterByEntityID, childEntityIDs, this.direction)
					.then((result) => {
						this.removeRecordAssoctaionModalOpen = false;
						this.selectedRecordsForCharType[selectedRemoveChildCharTypeID] = [];
						if (_.isEmpty(result.jobTitle)) {
							this.notifyService.notifyError("There was an error removing these records.");
						}
						else {
							var jobID = result.jobID;
							this.jobTitle = result.jobTitle;
							this.ShowProgress(jobID, () => {
								this.RefreshAll();
							});
						}
					}, (event) => {
						// error handler
						this.notifyService.notifyError("There was an error removing these records.");
					})
					.finally(() => {
						// end progress bar
						this.notifyService.endProgress();
					});
			}
			else {
				this.removeRecordAssoctaionModalOpen = false;
				this.selectedRecordsForCharType[selectedRemoveChildCharTypeID] = [];
				this.notifyService.notifyError("No associations found.");
			}
			this.notifyService.endProgress();
		}
	}
}
